@if (formService.formReady()) {
<div class="tw-flex tw-flex-col tw-h-full">

    <header class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-py-4 tw-px-6">
        <div class="tw-min-w-0 tw-flex-1">
            <h1 class="tw-m-0 tw-text-xl tw-font-medium tw-tracking-tight tw-text-[var(--sys-text)]" [appTruncatedText]="formService.title() | translate"
            >{{ formService.title() | translate }}</h1>
            @if (showUnitCount) {
                <div class="tw-text-sm tw-text-[var(--sys-secondary-text)]">{{ unitCountLabel() }}</div>
            }
        </div>

        <div class="tw-flex tw-gap-3 tw-flex-none">
            <app-barcode (onSubmitBarcode)="onBarcodeEnter($event)"></app-barcode>

            @if (canUseCameraBarcode) {
                <button type="button" mat-icon-button matSuffix [attr.aria-label]="'TOPBAR.ACTIONS.PHOTO_CAMERA' | translate" (click)="openCameraBarcode()">
                    <mat-icon>photo_camera</mat-icon>
                </button>
            }
            <app-action-btn variant="basic" (click)="goBack()">
                {{ 'STOCK.NEW_MOVEMENT.CANCEL' | translate }}
            </app-action-btn>
            <app-action-btn [disabled]="!canSave()" (click)="save()">
                {{ 'STOCK.NEW_MOVEMENT.SAVE' | translate }}
            </app-action-btn>
        </div>
    </header>

    <!-- Campi -->
    <form autocomplete="off" [formGroup]="form" class="tw-flex tw-flex-col tw-gap-1 tw-flex-1 tw-min-h-0 tw-overflow-y-auto tw-px-6 tw-pb-6">
        <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3
                xl:tw-grid-cols-none xl:tw-grid-flow-col xl:tw-auto-cols-fr tw-gap-x-4 tw-gap-y-1
                [&_.mdc-floating-label]:tw-max-w-full
                [&_.mat-mdc-input-element]:tw-text-ellipsis">

            @if (formService.showCauseAndSource) {
                <mat-form-field>
                    <mat-label>{{ (formService.isStockTransfer ? 'STOCK.TOPBAR_STOCK.SOURCE_LOCATION' : 'STOCK.TOPBAR_STOCK.STOCK_LOCATION') | translate }}</mat-label>
                    <mat-select formControlName="sourceLocationId">
                        @for (location of dataService.stockLocations(); track location.id) {
                            <mat-option [value]="location.id">{{ location.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-label translate>STOCK.TOPBAR_STOCK.CAUSE</mat-label>
                    <mat-select formControlName="movementCause" [compareWith]="formService.compareCauses">
                        @for (cause of formService.movementCauses; track cause.type + cause.value) {
                            <mat-option [value]="cause">{{ cause.typeName ? cause.typeName + ' - ' : '' }}{{ cause.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }

            @if (formService.showTargetLocation) {
                <mat-form-field>
                    <mat-label translate>STOCK.TOPBAR_STOCK.TARGET_LOCATION</mat-label>
                    <mat-select formControlName="targetLocationId">
                        @for (location of targetLocations(); track location.id) {
                            <mat-option [value]="location.id">{{ location.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }

            @if (formService.showSupplierFields) {
                <mat-form-field>
                    <mat-label translate>STOCK.TOPBAR_STOCK.SUPPLIER</mat-label>
                    <input matInput formControlName="supplier" [matAutocomplete]="supplierAuto">
                    <mat-autocomplete #supplierAuto="matAutocomplete" [displayWith]="displaySupplier"
                        (optionSelected)="formService.onSupplierSelect()">
                        @for (supplier of supplierOptions(); track supplier.id) {
                            <mat-option [value]="supplier">{{ supplier.name }}</mat-option>
                        }
                    </mat-autocomplete>
                    @if (formService.supplier.hasError('requireMatch')) {
                        <mat-error>{{ 'NG_MESSAGES.INVALID_VALUE' | translate }}</mat-error>
                    }
                </mat-form-field>
            }

            <tilby-datetime-picker class="tw-min-w-0" formControlName="date" label="STOCK.NEW_MOVEMENT.DATE_AND_TIME" />

            @if (formService.showSupplierFields) {
                <mat-form-field>
                    <mat-label translate>STOCK.TOPBAR_STOCK.ORDER_NUMBER</mat-label>
                    <input matInput formControlName="supplierOrder" appTrimInput
                        (click)="formService.onSupplierOrderClick()"
                        (blur)="formService.onSupplierOrderBlur()">
                </mat-form-field>
            }

            <mat-form-field>
                <mat-label translate>STOCK.TOPBAR_STOCK.NOTES</mat-label>
                <input matInput formControlName="notes">
            </mat-form-field>

            <!-- <mat-form-field>
                <mat-label translate>STOCK.MOVEMENTS.BARCODE</mat-label>
                <input matInput #barcodeField
                    (keydown.enter)="onBarcodeEnter(barcodeField.value); barcodeField.value = ''; $event.preventDefault()">
            </mat-form-field> -->
        </section>

        <div class="tw-border-0 tw-border-t tw-border-solid tw-border-[var(--sys-divider)] tw-mb-2 tw-ml-1"></div>

        <!-- Prodotti: la barra con le azioni resta visibile mentre l'elenco scorre -->
        <div class="tw-flex tw-flex-col">
            <div class="tw-sticky tw-top-0 tw-z-[2] tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-pb-3 tw-bg-[var(--sys-bg-container-body)]">
                <button type="button" mat-button color="primary" (click)="addRow()">
                    <div class="tw-flex tw-items-center">
                        <mat-icon class="tw-flex-none">add_circle</mat-icon>
                        <span class="tw-ml-2 tw-text-left">{{ 'STOCK.NEW_MOVEMENT.NAME' | translate }}</span>
                    </div>
                </button>

                @if (canGenerateSupplierOrder) {
                    <button type="button" mat-button color="primary" (click)="generateSupplierOrder()">
                        <div class="tw-flex tw-items-center">
                            <mat-icon class="tw-flex-none">auto_graph</mat-icon>
                            <span class="tw-ml-2 tw-text-left">{{ 'STOCK.NEW_MOVEMENT.SUPPLIER_ORDER_PROMPT_TITLE' | translate }}</span>
                        </div>
                    </button>
                }

                @if (formService.mode() === 'goods_delivery') {
                    <button type="button" mat-button color="primary" (click)="selectAllGoodsForDelivery()">
                        <div class="tw-flex tw-items-center">
                            <mat-icon class="tw-flex-none">library_add_check</mat-icon>
                            <span class="tw-ml-2 tw-text-left">{{ 'STOCK.NEW_MOVEMENT.ALL_GOODS_DELIVERY_CONFIRM' | translate }}</span>
                        </div>
                    </button>
                }
            </div>

            <div formArrayName="rows" class="tw-flex tw-flex-col">
                @for (row of rows.controls; track row; let i = $index) {
                    <div [formGroupName]="i" class="tw-flex tw-items-start tw-gap-3 tw-border-0 tw-border-t tw-border-solid tw-border-[var(--sys-divider)] first:tw-border-t-0 lg:tw-border-hidden tw-pt-4 first:tw-pt-0 lg:tw-py-0">
                        <button type="button" mat-icon-button class="tw-flex-none tw-mt-1"
                            [attr.aria-label]="'STOCK.NEW_MOVEMENT.REMOVE_MOVEMENT' | translate" (click)="removeRow(i)">
                            <mat-icon>delete_forever</mat-icon>
                        </button>

                        <div class="tw-grid tw-flex-1 tw-min-w-0 tw-grid-cols-1 tw-gap-x-4 md:tw-grid-cols-12
                            [&_.mdc-floating-label]:tw-max-w-full
                            [&_.mat-mdc-input-element]:tw-text-ellipsis">
                            <mat-form-field class="md:tw-col-span-12 lg:tw-col-span-4 tw-mb-2">
                                <mat-label translate>STOCK.NEW_MOVEMENT.NAME</mat-label>
                                <input matInput #entryInput formControlName="entry" [matAutocomplete]="entryAuto"
                                    #entryTrigger="matAutocompleteTrigger"
                                    (blur)="onEntryBlur(i, entryTrigger)">
                                <mat-autocomplete #entryAuto="matAutocomplete" [displayWith]="displayEntry"
                                    (optionSelected)="onEntrySelected(i)"
                                    (opened)="onEntryPanelOpened(i, entryAuto)"
                                    (closed)="onEntryPanelClosed(i, entryInput)">
                                    @for (entry of entryOptions(i); track entry) {
                                        <mat-option [value]="entry">{{ entryLabel(entry) }}</mat-option>
                                    }
                                </mat-autocomplete>
                                @if (entryOf(i)?.['sku']) {
                                    <mat-hint>{{ entryOf(i)?.['sku'] }}</mat-hint>
                                }
                            </mat-form-field>

                            <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-2 tw-mb-2">
                                <mat-label translate>STOCK.NEW_MOVEMENT.QUANTITY</mat-label>
                                <input matInput type="number" formControlName="quantity"
                                    (keydown.tab)="onQuantityTab(i, $event)">
                                <span matTextSuffix>{{ entryOf(i)?.['unit'] }}</span>
                                <mat-hint>{{ stockQuantity(i) }}</mat-hint>
                            </mat-form-field>

                            @if (dataService.showPriceData) {
                                <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-2 tw-mb-2">
                                    <mat-label translate>STOCK.NEW_MOVEMENT.PRICE</mat-label>
                                    <input matInput type="number" formControlName="price" min="0">
                                    <span matTextSuffix>{{ currencySymbol }}</span>
                                </mat-form-field>

                                <mat-form-field class="md:tw-col-span-6 lg:tw-col-span-2 tw-mb-2">
                                    <mat-label translate>STOCK.NEW_MOVEMENT.PERC_DISCOUNT</mat-label>
                                    <input matInput type="number" formControlName="perc_discount" min="0" max="100"
                                        (keydown.tab)="onLastFieldTab(i, $event)">
                                    <span matTextSuffix>%</span>
                                </mat-form-field>

                                <div class="tw-flex tw-flex-col tw-justify-center tw-pb-4 md:tw-col-span-6 lg:tw-col-span-2 tw-mb-2">
                                    <span class="tw-text-xs tw-text-[var(--sys-secondary-text)]" translate>STOCK.NEW_MOVEMENT.ROW_AMOUNT</span>
                                    <span>{{ rowAmountLabel(i) }}</span>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    </form>
</div>
}
